import { createSelector } from 'reselect'

import { selectPartner360Data } from './selectPartner360Data'

export const selectProgramTypes = createSelector([selectPartner360Data], ({ programTypes }) => {
  return programTypes
})
